import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import MenuList from './list';
import Modal from '../../../components/Modal/index';
import MenuAdd from './add';

class MenuConfig extends Component {
  constructor() {
    super();
  }
  componentDidMount() {}

  queryList = () => {
    // 查询列表
    this.props.dispatch({ type: 'menu/queryMenuConfig', params: {} });
  };

  add = () => {
    Modal.open({
      title: '新增',
      width: '1000px',
      content: (
        <MenuAdd
          closeModal={this.closeModal}
          actionType="add"
          treeData={this.props.menu}
        />
      ),
      isOkBtn: false,
      isCancelBtn: false
    });
  };

  edit = record => {
    Modal.open({
      title: '编辑',
      width: '1000px',
      content: (
        <MenuAdd
          closeModal={this.closeModal}
          actionType="update"
          treeData={this.props.menu}
          record={record}
        />
      ),
      isOkBtn: false,
      isCancelBtn: false
    });
  };
  closeModal = () => {
    Modal.close();
    this.queryList();
  };
  render() {
    const { menu } = this.props;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <MenuList data={menu} edit={this.edit} queryList={this.queryList} />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ...state.menu
  };
}

export default connect(mapStateToProps)(MenuConfig);
